import { QueryClient } from "@tanstack/react-query";

import { ApiRequestError } from "../api/apiClient.js";

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (attempt, error) => {
          // Fehler des Aufrufers wiederholen sich nicht von selbst: ein 403 bleibt
          // ein 403, und ein zweiter Versuch kostet nur Zeit.
          if (error instanceof ApiRequestError && error.status < 500) {
            return false;
          }
          return attempt < 2;
        },
      },
    },
  });
}
